import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { getItemFromStorage } from '@utils/storage'

const PreventedRoute = ({ children, component: Component, ...rest }) => {
  const token = getItemFromStorage('token') || null

  return (
    <Route
      {...rest}
      render={props => (token ? <Component {...props} /> : <Redirect to="/" />)}
    />
  )
}

export default PreventedRoute
